export default "__VITE_ASSET__w6KkZdYa__"